import React, { Component, Fragment } from 'react';
import _set from 'lodash/set';
import _get from 'lodash/get';

import TextField from 'material-ui/TextField';
import DropDownMenu from 'material-ui/DropDownMenu';
import MenuItem from 'material-ui/MenuItem';
import { Table, TableBody, TableRow, TableRowColumn } from 'material-ui/Table';

import api from 'services';
import { getNormalErrors, showNotification } from 'helpers';

function transformRegion(region) {
  return {
    ...region,
    dwtGroup: Object.keys(region.dwtGroup).reduce((res, type) => {
      res[type] = region.dwtGroup[type].reduce((resType, value) => {
        resType[value.nameDwtGroup] = value.averagePortCostsUsdDay

        return resType;
      }, {})

      return res;
    }, {})
  }
}

export default class Region extends Component {

  constructor(props) {
    super(props);

    this.state = {
      data: this.transformRegion(this.props.data),
      ts: this.props.ts,
      unfold: this.props.unfold,
      defaultUnfold: this.props.unfold,
      errors: {}
    }
  }

  static getDerivedStateFromProps(props, state) {
    if (
      _get(state, 'data._id', null) != _get(props, 'data._id', null)
      || state.ts != props.ts
    ) {
      let unfoldChange = {}

      if (_get(state, 'defaultUnfold', null) != _get(props, 'unfold', null)) {
        unfoldChange = {
          unfold: props.unfold,
          defaultUnfold: props.unfold
        }
      }

      return {
        data: transformRegion(props.data),
        ts: props.ts,
        ...unfoldChange
      }
    }

    return null;
  }

  transformRegion = transformRegion

  toggleUnfold = () => {
    this.setState({unfold: !this.state.unfold});
  }

  handleChange(changes = []) {

    function validateValue(value) {
      if (typeof value !== 'boolean') {
        let dots = 0;
        value = value
          .replace(/[^\d|\.|-]/, '')
          .replace(/\./g, function() { return dots++ > 0 ? '' : '.'; })
          .replace(/\-/g, function(match, str) { return str === 0 ? '-' : '' });
      }
      return value;
    }

    let data = JSON.parse(JSON.stringify(this.state.data));
    let errors = {};

    changes.forEach(v => {
      _set(data, v.key, validateValue(v.value));
      if (!v.noError) {
        errors[v.key] = v.value && typeof v.value !== 'boolean' && !isNaN(parseFloat(v.value)) ? '' : 'required'
      }
    })

    this.setState({
      data,
      errors: {
        ...this.state.errors,
        ...errors
      }
    })
  }

  save = async () => {
    let { data, errors } = this.state;
    let { tcRates } = this.props;

    if (
      Object.keys(errors).reduce((res, key) => {
        if (errors[key]) {
          res = true;
          return res;
        }
      }, false)
    ) {
      return showNotification('There is an error. Check out inputs', 'error');
    }

    let result = await api.disbursement.updateOne({
      ...data,
      dwtGroup: Object.keys(data.dwtGroup).reduce((res, type) => {
        res[type] = Object.keys(data.dwtGroup[type]).reduce((resGroup, key) => {
          resGroup.push({
            nameDwtGroup: key,
            averagePortCostsUsdDay: data.dwtGroup[type][key]
          })

          return resGroup;
        }, [])

        return res;
      }, {})
    });

    if (result.status === 200) {
      showNotification('Region has been updated');
      return await this.props.getRegions()
    }

    showNotification(getNormalErrors(result).error, 'error')
  }

  remove = async () => {
    await this.props.removeRegion(this.state.data._id);
  }

  render() {
    let { data: { dwtGroup }, data, unfold = true, errors } = this.state;
    let { dwtGroups } = this.props;
    let name = data.type === 'country' ? _get(data, 'country.name', '') + ' (country)' : _get(data, 'region.name', '') + ' (port)';

    return (
      <TableRow style={{borderBottom: '4px solid rgb(224, 224, 224)'}}>
        <TableRowColumn style={{width: '20%'}}>
          {
            unfold ?
              <Fragment>
                <p>{name}</p>
                <DropDownMenu
                  value={'save'}
                  style={{padding: 0}}
                  onChange={(e, key, handler) => this[handler]()}
                >
                  <MenuItem value='save' primaryText="save" />
                  <MenuItem value='remove' primaryText="remove" />
                </DropDownMenu>
              </Fragment>
            :
              <p
                onClick={this.toggleUnfold}
                style={{cursor: 'pointer'}}
              >
                {name}
              </p>
          }
        </TableRowColumn>

        {
          unfold ?
            <Fragment>
              <TableRowColumn>
                <Table>
                  <TableBody displayRowCheckbox={false}>
                    {
                      Object.keys(dwtGroups.mpp).map((key, i) => {
                        return (
                          <TableRow key={`dwt-group-name-${i}`}>
                            <TableRowColumn>
                              {dwtGroups.mpp[key]}
                            </TableRowColumn>
                          </TableRow>
                        )
                      })
                    }
                    <TableRow key={`dwt-group-name-100`}>
                      <TableRowColumn>
                      </TableRowColumn>
                    </TableRow>
                  </TableBody>
                </Table>
              </TableRowColumn>

              <TableRowColumn>
                <Table>
                  <TableBody displayRowCheckbox={false}>
                    {
                      Object.keys(dwtGroup.mpp).map((key, j) => {
                        return (
                          <TableRow key={`tc-rate-${j}`}>
                            <TableRowColumn>
                              <TextField
                                value={dwtGroup.mpp[key]}
                                hintText='0'
                                onChange={(e, value) => {
                                  this.handleChange([{key: `dwtGroup.mpp.${key}`, value}])
                                }}
                                fullWidth
                                errorText={errors[`dwtGroup.mpp.${key}`] ? 'required' : ''}
                              />
                            </TableRowColumn>
                          </TableRow>
                        )
                      })
                    }
                    <TableRow key={`tc-rate-100`}>
                      <TableRowColumn>
                      </TableRowColumn>
                    </TableRow>
                  </TableBody>
                </Table>
              </TableRowColumn>

              <TableRowColumn>
                <Table>
                  <TableBody displayRowCheckbox={false}>
                    {
                      Object.keys(dwtGroups.bulk).map((key, i) => {
                        return (
                          <TableRow key={`dwt-group-name-${i}`}>
                            <TableRowColumn>
                              {dwtGroups.bulk[key]}
                            </TableRowColumn>
                          </TableRow>
                        )
                      })
                    }
                  </TableBody>
                </Table>
              </TableRowColumn>

              <TableRowColumn>
                <Table>
                  <TableBody displayRowCheckbox={false}>
                    {
                      Object.keys(dwtGroup.bulk).map((key, j) => {
                        return (
                          <TableRow key={`tc-rate-${j}`}>
                            <TableRowColumn>
                              <TextField
                                value={dwtGroup.bulk[key]}
                                hintText='0'
                                onChange={(e, value) => {
                                  this.handleChange([{key: `dwtGroup.bulk.${key}`, value}])
                                }}
                                fullWidth
                                errorText={errors[`dwtGroup.bulk.${key}`] ? 'required' : ''}
                              />
                            </TableRowColumn>
                          </TableRow>
                        )
                      })
                    }
                  </TableBody>
                </Table>
              </TableRowColumn>
            </Fragment>
          :
            <Fragment>
              <TableRowColumn>
              </TableRowColumn>
              <TableRowColumn>
              </TableRowColumn>
            </Fragment>
        }
      </TableRow>
    )
  }
}



// WEBPACK FOOTER //
// ./app/components/Disbursement/Region.js